module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-7.3c71a147.png";